<template>
    <b-container fluid class="py-3 disposal_screen">
        <b-row>
            <b-col>
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                    <Tableview :value="items" :paginator="false" class="p-datatable-gridlines commonstatusclass"
                        :rows="10" :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
                        :globalFilterFields="globalFilterFields" :filters="filters" :totalRecords="rowsCount"
                        :state="state" @ShowRows="ShowRows" :loading="loading">
                        <template v-slot:action="{ data }">
                            <span>
                                <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                                    @click="toggle($event, data)" :disabled="data.ApprovalStatus === '2'" />
                            </span>
                        </template>
                        <template v-slot:Status="{ data }">
                            <RedStatus name="Flagged for Disposal" v-if="data.Status === '1'" />
                            <GreenStatus name="Active" v-else-if="data.Status === '0'" />
                        </template>
                        <template v-slot:DisposalStatus="{ data }">
                            <RedStatus name="Rejected" v-if="data.ApprovalStatus === '2'" />
                            <GreenStatus name="Approved" v-else-if="data.ApprovalStatus === '1'" />
                            <OrangeStatus name="Pending" v-else-if="data.ApprovalStatus === '0'" />
                        </template>
                        <template v-slot:Add>
                            <span>
                                <AddButton :btnname="t('btn.plusaddnew')" @click="IsAdd"></AddButton>
                            </span>
                        </template>
                    </Tableview>
                </div>
                <Menu ref="menu" id="overlay_menu" :model="itemListed" :popup="true" />
            </b-col>
        </b-row>
    </b-container>
    <Disposalrejectionpopup v-model:reject_pop="reject_pop" :datas="ObjData" v-if="reject_pop" @closepopup="isClear" />
    <DisposalRequestForm v-model:resquest_form="resquest_form" v-if="resquest_form" @closepopup="isClear" />
    <ApprovePopup v-model:approve_pop="approve_pop" :datas="ObjData" v-if="approve_pop" @closepopup="isClear" />
</template>
<script lang="ts">
import { defineComponent, ref, computed, onMounted, reactive, watch } from 'vue'
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Disposalrejectionpopup from './Disposalrejectionpopup.vue';
import DisposalRequestForm from '../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/view/Disposal/disposalRequestForm.vue';
import DisposalService from '../../../../../../../modules/Inventory/Service/AssetManagement/DisposalService';
import { useI18n } from 'vue-i18n';
import ApprovePopup from './ApprovePopup.vue';
import { useRouter, useRoute } from "vue-router";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
export default defineComponent({
    components: {
        Tableview,
        Disposalrejectionpopup,
        DisposalRequestForm,
        ApprovePopup,
        SkeletonTableLoader,
    },
    setup() {
        const loading = ref(false);
        const menu = ref();
        const reject_pop = ref();
        const resquest_form = ref()
        const ObjData = ref();
        const routes = useRoute();
        const toggle = (event, data) => {
            ObjData.value = data;
            console.log('rows', ObjData);
            menu.value.toggle(event);
        };
        const { t } = useI18n();
        const approve_pop = ref()
        const rowsCount = ref(0);
        const state = reactive({
            pagedItems: [], // contains a subset of rows for the current page
            currentPage: 1, // current page number
            pageSize: 10, // number of rows per page
            totalRows: 0, // total number of rows in the database
        });
        let items = ref([]);
        const datefilter = ref({
            fromdate: '01/01/1800',
            todate: '01/01/9999'
        })

        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }

        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }

        let SessionEntityData = localStorage.getItem("EntityData");
        let EntityData;
        if (SessionEntityData !== null) {
            EntityData = JSON.parse(SessionEntityData);
        }
        let HospitalId = Number(usersData.OrganizationId);
        const ParamValues = ref({
            StoreId: Number(routes.query.Id ?? 0),
            BranchId: Number(routes.query.BranchId ?? 0),
        });


        const itemListed = ref([
            {
                items: [
                    {
                        label: t('assetManagement.Disposal.Approve'),
                        visible: computed(() => ObjData.value.ApprovalStatus !== "2"),
                        command: async () => {
                            approveHandle();
                        },
                    },
                    {
                        label: t('assetManagement.Disposal.Reject'),
                        visible: computed(() => ObjData.value.ApprovalStatus !== "2"),
                        command: async () => {
                            rejectionHandle();
                        },
                    },

                ],
            },
        ]);
        const headers = [
            {
                header: t('assetManagement.Disposal.SNo'),
                field: "RowNumber",
            },
            {
                header: t('assetManagement.Disposal.Asset Name'),
                field: "AssetName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('assetManagement.Disposal.Barcode'),
                field: "BarCode",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('assetManagement.Disposal.Category'),
                field: "Category",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('assetManagement.Disposal.CurrentStatus'),
                field: "CurrectStatus",
                slot: "Status",
                fieldDisplay: "false",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('assetManagement.Disposal.Location'),
                field: "Location",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('assetManagement.Disposal.DisposalStatus'),
                field: "DisposalStatus",
                slot: "DisposalStatus",
                fieldDisplay: "false",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('assetManagement.Disposal.Action'),
                field: "action",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                class: "filterdisplaynone last-column-position",
                fieldDisplay: "false",
            }
        ]
        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            AssetName: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
            Barcode: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
            Category: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
            Status: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
            Location: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
            DisposalStatus: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
        };
        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });
        const globalFilterFields = ref(headers.map((col) => col.field));
        function ShowRows(value) {
            debugger;
            if (value != 0 && value != null && value != undefined) {
                state.pageSize = value;
                IsShow();
            }
        }
        watch(
            [() => state.currentPage, () => state.pageSize],
            async ([pageNum, pageSize]) => {
                debugger;
                await IsShow();
            }
        );
        function approveHandle() {
            approve_pop.value = true;
        }
        function isClear() {
            reject_pop.value = false;
            resquest_form.value = false;
            approve_pop.value = false;
            IsShow();
        }
        function rejectionHandle() {
            reject_pop.value = true;
        }
        function IsAdd() {
            resquest_form.value = true;
        }
        const IsShow = async () => {
            try {
                loading.value = true;
                const pageNum = state.currentPage;
                //  const pageSize = state.pageSize;
                let count = 0;
                const pageSize = 1;

                const response = await DisposalService.getdata(
                    ParamValues.value.StoreId, ParamValues.value.BranchId, HospitalId,
                    datefilter.value.fromdate,
                    datefilter.value.todate,
                    pageNum,
                    pageSize);
                console.log('getdata', response);
                items.value = response["result"].requestList.map((item: any) => {
                    count = count + 1;
                    item.RowNumber = count;
                    return item;
                });
                rowsCount.value =
                    response["result"].requestList.length > 0
                        ? response["result"].requestList["rowscount"]
                        : 0;
                loading.value = false;
            } catch (error) {
                console.error('Error fetching data:', error);

            }
        };
        onMounted(() => {
            IsShow();
        });
        return {
            items,
            loading,
            filteredColumns,
            globalFilterFields,
            headers,
            filters,
            toggle,
            menu,
            itemListed,
            approveHandle,
            rejectionHandle,
            isClear,
            reject_pop,
            resquest_form,
            IsAdd,
            IsShow,
            state,
            ShowRows,
            rowsCount,
            datefilter,
            t,
            approve_pop,
            ObjData,
            ParamValues,
            HospitalId
        }
    }

})
</script>

<style lang="scss" scoped></style>